// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2dN74ewQk37enDTNzw-e29 {\n    max-width: 350px;\n    margin: 0px auto 0px;\n    padding-top: 8px;\n    width: auto;\n}\n\n.Pt_VrS0QmgirjRJokwLYP {\n    margin-top: 6px;\n}\n\n.u0r9lc15vBgegc20eaBIl {\n    margin: 20px 5px 0 0 !important;\n}\n\n.K8lKYqUxI8Pr-uO0QaGa2 {\n    position: relative;\n    height: 0;\n    overflow: hidden;\n    flex-basis: initial !important;\n    z-index: -1;\n}\n\n._349pJtbwXmSK_VDhJMUDQp {\n    margin-bottom: 16px;\n    padding-bottom: 16px;\n}\n\n._2RhXIZJubi6ZmBcNx3WYB2 {\n    font-size: 12px;\n    line-height: 16px;\n    color: #32445a;\n    font-weight: 500;\n    margin-top: -10px;\n    margin-left: 8px;\n    margin-bottom: 40px;\n}\n\n._2jeQ5gEv0WJsbEQTFZ9XRQ {\n    min-width: 280px !important; \n}\n\n._2RFgPh-Oo6EvvIQuGQIB1S {\n    padding-top: 16px;\n}\n\n._1eMlcf-Wl-fAS8LjbJhVQZ {\n    box-shadow: none !important;\n}\n", ""]);
// Exports
exports.locals = {
	"form": "_2dN74ewQk37enDTNzw-e29 skinny",
	"button": "Pt_VrS0QmgirjRJokwLYP",
	"checkbox": "u0r9lc15vBgegc20eaBIl",
	"invisibleButFillable": "K8lKYqUxI8Pr-uO0QaGa2",
	"loginCard": "_349pJtbwXmSK_VDhJMUDQp",
	"rememberLabel": "_2RhXIZJubi6ZmBcNx3WYB2",
	"loginButton": "_2jeQ5gEv0WJsbEQTFZ9XRQ",
	"codeMessage": "_2RFgPh-Oo6EvvIQuGQIB1S",
	"borderlessCard": "_1eMlcf-Wl-fAS8LjbJhVQZ"
};
module.exports = exports;
